
const headers = [
    {
      label: 'เลขร้องทุกข์',
      field: 'complaintCode',
    },
    {
      label: 'ดำเนินการ',
      field: 'qllName',
    },
    {
      label: 'สถานะ',
      field: 'qllStatus',
    },
    {
      label: 'หมายเหตุ',
      field: 'qllRemark',      
    },
    {
      label: 'จัดการ',
      field: 'action', 
    },
  ]

  export default headers